import { RouteConfig } from "vue-router";
import LoginPage from "./login/index.vue";

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { isAuth: false, title: "POSRocket | Login" },
  },
  {
    path: "/logout",
    name: "log-Out",
    component: LoginPage,
    meta: { isAuth: false, title: "POSRocket | log-out" },
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () => import("./reset/index.vue"),
    meta: { isAuth: false, title: "POSRocket | Reset password" },
  },
];

export default routes;
